import React, { useContext } from 'react'

export const TemplatesContext = React.createContext({
  templates: [],
  setTemplates: () => {},
})

export const useTemplates = () => useContext(TemplatesContext)
